module.exports = __webpack_public_path__ + "static/media/table_background_3.43458f12.jpg";